import React from 'react'

import { ZariContext } from '_zari/context'

import { Table, Modal, Col, Row, Button } from '_zari/core'

import { IdGen } from 'utils'

import * as TransaccionCrud from 'services/transaccion.service'

import * as Sections from './sections'

const EditarCuentas12Modal = ({ modalData, handleClose, show, idTransaccion }) => {
  const __zariContext = React.useContext(ZariContext)

  const [cuentas12, setCuentas12] = React.useState(modalData)
  const [sectionKey, setSectionKey] = React.useState(null)

  const edicionDataRef = React.useRef({})

  const refrescarTabla = React.useCallback(() => {
    TransaccionCrud.getTransaccionCuentas12(idTransaccion)
      .then(({ data }) => {
        setCuentas12(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, idTransaccion])

  React.useEffect(() => {
    refrescarTabla()
  }, [refrescarTabla])

  const refrescarSection = React.useCallback(() => {
    edicionDataRef.current = {}
    setSectionKey(IdGen.newId())
  }, [])

  const clickEditar = React.useCallback(
    idModeloCuenta => {
      TransaccionCrud.getModeloCuentas12xId(idTransaccion, idModeloCuenta)
        .then(({ data }) => {
          edicionDataRef.current = data
          setSectionKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, idTransaccion]
  )

  const clickEliminar = React.useCallback(
    idModeloCuenta => {
      TransaccionCrud.eliminarTransaccionCuentas12(idTransaccion, idModeloCuenta)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado.')
          refrescarTabla()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, refrescarTabla, idTransaccion]
  )

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>CUENTAS 12</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Table
              maxRowsShown={5}
              headRows={[{ label: 'Descripcion' }, { label: 'Soles' }, { label: 'Dolares' }, { label: 'Euros' }, { label: '' }, { label: '' }]}
              filas={cuentas12}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.descripcion || '--'}</Table.Cell>
                  <Table.Cell>{row.cuentaContable12PEN || '--'}</Table.Cell>
                  <Table.Cell>{row.cuentaContable12USD || '--'}</Table.Cell>
                  <Table.Cell>{row.cuentaContable12EUR || '--'}</Table.Cell>
                  <Table.Cell>
                    <Button tiny color='secondary' outline onClick={() => clickEditar(row._id)}>
                      Editar
                    </Button>
                    <Button tiny color='danger' outline onClick={() => clickEliminar(row._id)}>
                      Eliminar
                    </Button>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
          <Col md={6}>
            <Sections.CrearEditarSection
              key={sectionKey}
              idTransaccion={idTransaccion}
              refrescarTabla={refrescarTabla}
              editarData={edicionDataRef.current}
              refrescarSection={refrescarSection}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditarCuentas12Modal
